module.exports = __webpack_public_path__ + "static/media/24.05ccee6f.mp3";